import { tail } from 'lodash';
import { SeatConfigurationRequest } from '~client/model/admin/seat-configuration-request';
import { AddSeatConfigurationFormData } from '~admin/view/components/details/event-details/event-location-details/add-seat-configuration-overlay.component';
import { SeatConfigurationCategoryDetail } from '~client/model/admin/seat-configuration-category-detail';
import { SeatConfigurationSectionData } from '~client/model/admin/seat-configuration-section-data';
import { SeatConfigurationTranslation } from '~client/model/admin/seat-configuration-translation';
import { SeatConfigurationCategoryItemFormData } from '~admin/view/components/details/event-details/event-location-details/seat-configuration-category-item-fields.component';
import {
  isNilOrEmptyTranslationString,
  mapTranslations,
  mergeTranslations,
} from '~admin/view/components/create-event/helper/merge-translations.helper';
import { Language } from '~common/i18n';

const buildCategoryDetailMap = (
  categoryData: SeatConfigurationCategoryItemFormData[],
): { [key: string]: SeatConfigurationCategoryDetail } => {
  const categoryDetailMap: { [key: string]: SeatConfigurationCategoryDetail } = {};
  categoryData.forEach((data: SeatConfigurationCategoryItemFormData) => {
    const {
      name,
      accessibilityType,
      categoryDetail,
      emailRules,
      rules,
      externalTaxCode,
      minimumUserAge,
    } = data;
    categoryDetailMap[name[0].value] = {
      accessibilityType,
      externalTaxCode,
      minimumUserAge,
      detail: isNilOrEmptyTranslationString(categoryDetail) ? null : categoryDetail[0].value,
      emailRules: isNilOrEmptyTranslationString(emailRules) ? null : emailRules[0].value,
      rules: isNilOrEmptyTranslationString(rules) ? null : rules[0].value,
    };
  });
  return categoryDetailMap;
};

const buildSectionList = (
  categoryData: SeatConfigurationCategoryItemFormData[],
): SeatConfigurationSectionData[] =>
  categoryData.map(
    (data: SeatConfigurationCategoryItemFormData): SeatConfigurationSectionData => ({
      category: data.name[0].value,
      count: data.yoopCount,
      name: data.name[0].value,
    }),
  );

const buildSetConfigurationTranslation = (
  categoryData: SeatConfigurationCategoryItemFormData[],
): SeatConfigurationTranslation => {
  const categoryTranslation: { [key: string]: { [key: string]: string } } = {};
  const categoryDetailTranslation: {
    [key: string]: { [key: string]: SeatConfigurationCategoryDetail };
  } = {};
  categoryData.forEach((data: SeatConfigurationCategoryItemFormData) => {
    const primaryName = data.name[0].value;
    const currentCategoryTranslations = new Map<Language, SeatConfigurationCategoryDetail>();
    mergeTranslations(currentCategoryTranslations, 'detail', data.categoryDetail);
    mergeTranslations(currentCategoryTranslations, 'emailRules', data.emailRules);
    mergeTranslations(currentCategoryTranslations, 'rules', data.rules);
    categoryDetailTranslation[primaryName] = mapTranslations(currentCategoryTranslations);
    categoryTranslation[primaryName] = {};
    tail(data.name).forEach((translation) => {
      categoryTranslation[primaryName][translation.language] = translation.value;
    });
  });
  return {
    categoryDetailTranslation: categoryDetailTranslation,
    categoryTranslation: categoryTranslation,
    sectionTranslation: categoryTranslation,
    supportedLocales: Object.values(Language),
  };
};

/**
 * Transforms AddSeatConfigurationFormData to SeatConfigurationRequest
 */
export const getSeatConfigurationRequest = (
  request: AddSeatConfigurationFormData,
  eventLocationId: number,
): SeatConfigurationRequest => {
  const { seatConfigurationName, categoryData } = request;
  return {
    locationProfileId: eventLocationId,
    name: seatConfigurationName,
    categoryDetailMap: buildCategoryDetailMap(categoryData),
    seatConfigurationSectionList: buildSectionList(categoryData),
    seatConfigurationTranslation: buildSetConfigurationTranslation(categoryData),
  };
};



// WEBPACK FOOTER //
// ./view/components/create-event/helper/seat-configuration-request.helper.ts